module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.BOrder.expressContactor))])]), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v(_vm._s(_vm.BOrder.expressAddress))]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.BOrder.expressPhone))])])])]), _vm._v(" "), (_vm.BOrder.merchandises.length > 0) ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.BOrder.merchandises), function(merchandise) {
    return _c('ul', {
      staticStyle: {
        "margin": "5px 5% 0 5%",
        "width": "90%"
      }
    }, [_c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.goToDetail(merchandise)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((merchandise._titleList), function(title) {
      return (title.valueText !== '-1') ? _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, _vm._l((merchandise._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [(abstract.valueText && abstract.valueText !== '-1') ? _c('span', {
        staticStyle: {
          "font-size": "xx-small",
          "margin": ".3rem .3rem .8rem 0"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "1.5rem"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(merchandise.selfOperated === 0) ? _c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#1482E7"
      }
    }, [_vm._v("【第三方】")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(merchandise.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(merchandise.workdays) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(merchandise.workdays) + "工作日")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(merchandise.categoryId === 20 || merchandise.categoryId === 10) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("定制")]) : _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")])])])]), _vm._v(" "), (merchandise.discountPrice && merchandise.discountPrice != 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v(" ￥"), _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('hr'), _vm._v(" "), _c('div', [_vm._v(_vm._s(merchandise.merchandiseLabel))]), _vm._v(" "), (merchandise.quantity) ? _c('div', {
      staticStyle: {
        "color": "#6e727b",
        "float": "left"
      }
    }, [_vm._v("合计" + _vm._s(merchandise.quantity) + "个产品")]) : _c('div', {
      staticStyle: {
        "color": "#6e727b",
        "float": "left"
      }
    }, [_vm._v("合计" + _vm._s(1) + "个产品")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem",
        "float": "right"
      }
    }, [_vm._v(" ￥\n                  "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")]) : (merchandise.price && merchandise.price !== 0) ? _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.price) + " ")]) : _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")])])])])])])])
  }), 0) : _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.BOrder.subOrders), function(suborder) {
    return _c('div', _vm._l((suborder.merchandises), function(merch) {
      return _c('div', {
        staticStyle: {
          "margin": "5px 5% 0 5%",
          "width": "90%"
        }
      }, [_c('ul', [_c('li', [_c('a', {
        staticClass: "item-link item-content",
        on: {
          "click": function($event) {
            return _vm.goToDetail(merch)
          }
        }
      }, [_c('div', {
        staticClass: "item-inner",
        staticStyle: {
          "padding-bottom": "0rem"
        }
      }, [_c('div', {
        staticClass: "item-title-row"
      }, [_c('div', {
        staticClass: "item-title"
      }, _vm._l((merch._titleList), function(title) {
        return (title.valueText !== '-1') ? _c('span', {
          staticStyle: {
            "margin-right": ".3rem"
          }
        }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('div', {
        staticClass: "item-subtitle",
        staticStyle: {
          "font-size": "xx-small"
        }
      }, _vm._l((merch._abstractList), function(abstract) {
        return _c('label', {
          staticClass: "label-checkbox checkbox-el "
        }, [(abstract.valueText && abstract.valueText !== '-1') ? _c('span', {
          staticStyle: {
            "font-size": "xx-small",
            "margin": ".3rem .3rem .8rem 0"
          }
        }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "item-text",
        staticStyle: {
          "height": "1.5rem"
        }
      }, [_c('div', {
        staticStyle: {
          "height": "1.6rem"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left"
        }
      }, [(merch.selfOperated === 0) ? _c('span', {
        staticStyle: {
          "font-size": "x-small",
          "color": "#1482E7"
        }
      }, [_vm._v("【第三方】")]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "font-size": ".5rem"
        }
      }, [(merch.categoryId === 20 || merch.categoryId === 10) ? _c('span', {
        staticClass: "sub-span"
      }, [_vm._v("定制")]) : _c('span', [_c('span', {
        staticClass: "sub-span"
      }, [_vm._v("现货")]), _vm._v(" "), _c('span', {
        staticClass: "sub-span"
      }, [_vm._v("减券")])])])])]), _vm._v(" "), (merch.discountPrice && merch.discountPrice != 0) ? _c('div', {
        staticClass: "item-title-row"
      }, [_c('div', {
        staticClass: "item-title",
        staticStyle: {
          "color": "#6e727b"
        }
      }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#00469A",
          "font-size": "0.1rem"
        },
        attrs: {
          "lass": "item-after"
        }
      }, [_vm._v(" ￥"), _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_c('hr'), _vm._v(" "), (merch.quantity) ? _c('div', {
        staticStyle: {
          "color": "#6e727b",
          "float": "left"
        }
      }, [_vm._v("合计" + _vm._s(merch.quantity) + "个产品")]) : _c('div', {
        staticStyle: {
          "color": "#6e727b",
          "float": "left"
        }
      }, [_vm._v("合计" + _vm._s(1) + "个产品")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#00469A",
          "font-size": "0.1rem",
          "float": "right"
        }
      }, [_vm._v(" ￥\n                      "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.priceMax) + " ")]) : (merch.price && merch.price !== 0) ? _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.price) + " ")]) : _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.priceMax) + " ")])])])])])])])])
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.createOrderDT))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("结算方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.payTypeName))])])])]), _vm._v(" "), (_vm.BOrder.balanceType === _vm.balanceTypeResearch) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("课题组名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.researchGroupName))])])])]) : _vm._e(), _vm._v(" "), (_vm.BOrder.settlementAccountNo) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("结算账户编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.settlementAccountNo))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceTypeName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceTitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票内容")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceContent))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.initPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("运费")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.expressPrice))])])])]), _vm._v(" "), (_vm.BOrder.discountPrice && _vm.BOrder.discountPrice != 0) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("-￥" + _vm._s(_vm.BOrder.discountPrice))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("实支付")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.totalPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  })])])]), _vm._v(" "), _c('footer', {
    staticClass: "bar bar-tab"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "float": "right",
      "margin-top": "0"
    }
  }, [(_vm.BOrder.status === 11 && _vm.merchandises[0].categoryId === 20 && (_vm.merchandises[0]._attributes.ReguTech === undefined || _vm.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
    staticClass: "gotopay_button_style",
    on: {
      "click": function($event) {
        return _vm.buyAgain1(_vm.BOrder)
      }
    }
  }, [_vm._v("我要扩增")]) : _c('span', {
    staticClass: "gotopay_button_style",
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("再次购买")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("订单详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": ".3rem"
    }
  }, [_c('button', {
    staticClass: "button workdays"
  }, [_vm._v("周期20个工作日")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154f2b74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyOrder/order/detail/OrderDetail.vue
// module id = 1546
// module chunks = 8